export const getAssetPrefix = () => {
  if (process.env.NODE_ENV === 'development') {
    return '/';
  }
  let prefix = `/${process.env.ASSETS_PREFIX_SHA}`;

  if (process.env.CDN_DOMAIN) {
    prefix = `${process.env.CDN_DOMAIN}${prefix}`;
  }

  return prefix;
};

export const getPublicFileURL = (relativePath: string) => {
  if (process.env.NODE_ENV === 'development') {
    return relativePath;
  }
  return `${import.meta.env.BASE_URL}${relativePath}`;
};
